module.exports = __webpack_public_path__ + "4c305cb5789885ebe4adc30df3748bd8.png";